import { render, staticRenderFns } from "./Evaluaciones.vue?vue&type=template&id=1ba65c32&scoped=true"
import script from "./Evaluaciones.vue?vue&type=script&lang=js"
export * from "./Evaluaciones.vue?vue&type=script&lang=js"
import style0 from "./Evaluaciones.vue?vue&type=style&index=0&id=1ba65c32&prod&lang=scss&scoped=true"
import style1 from "./Evaluaciones.vue?vue&type=style&index=1&id=1ba65c32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba65c32",
  null
  
)

export default component.exports